// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-74416353]{text-align:left;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;padding:20px 24px 30px 24px}.container h1[data-v-74416353]{font-weight:700}.container h2[data-v-74416353],.container h3[data-v-74416353]{margin-top:20px}.container h3[data-v-74416353]{font-style:italic}.container p[data-v-74416353]{margin-top:20px}.container ul[data-v-74416353]{margin-top:15px;list-style-type:disc;padding-left:20px}", ""]);
// Exports
module.exports = exports;
